module.exports = __webpack_public_path__ + "img/img1.a20c5b2b.jpg";